<template>
  <div class="filters mb-4">
    <div class="input-search-wrapper mb-4 row">
      <div class="col-lg-7 col-xl-5 col-xxl-4">
        <label
          for="search-input"
          class="form-label visually-hidden"
          v-html="$store.state.i18n.label_search"
        ></label>

        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="search-input"
            :placeholder="$store.state.i18n.placeholder"
            @input="debounceSearch"
          />
          <span class="input-group-text"><i class="fal fa-search"></i></span>
        </div>
      </div>
    </div>

    <div class="more-wrapper row align-items-center">
      <show-at :breakpoints="{ medium: 992 }" breakpoint="large">
        <div class="col-lg-10">
          <PosttypeFilter />
        </div>
      </show-at>

      <div class="col-lg-2">
        <div class="text-center wrapper-more-filter">
          <button
            class="btn btn-more-filter"
            type="button"
            @click="filtersAreOpen = !filtersAreOpen"
          >
            <svg
              class="picto"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 28.35 28.35"
            >
              <path d="M1.45,7.81H26.9" />
              <path d="M6,14.17H22.35" />
              <path d="M11.45,20.54H16.9" />
            </svg>
            {{ $store.state.i18n.more_filter }}
          </button>
        </div>
      </div>

      <div
        class="dropdown-menu"
        ref="dropdown"
        :class="{ open: filtersAreOpen }"
      >
        <div class="row">
          <show-at :breakpoints="{ medium: 992 }" breakpoint="mediumAndBelow">
            <div class="col-xl-6 col-xxl-4 mb-4 mb-xxl-0">
              <PosttypeFilter />
            </div>
          </show-at>

          <div class="row">
            <div
              class="col-lg-4 col-xxl mb-4 mb-xxl-0"
              v-for="(taxonomy, index) in $store.state.taxonomies"
              :key="taxonomy.taxonomy"
            >
              <CheckboxFilter :tax="taxonomy" :tax_key="index" />
            </div>
          </div>

          <div
            class="col post-tags-list mt-4 mt-lg-0 mt-xxl-4"
            v-if="$store.state.tags_list.length"
          >
            <p class="filter-title mt-4" v-html="$store.state.i18n.topics"></p>
            <button
              v-for="tag in $store.state.tags_list"
              :key="tag.type_name + '_' + tag.term_id"
              v-html="'#' + tag.name"
              class="btn btn-post-tag"
              @click="tagClick(tag.name, tag.term_id)"
            ></button>
          </div>

          <show-at :breakpoints="{ medium: 992 }" breakpoint="mediumAndBelow">
            <button
              class="btn btn-more-filter"
              type="button"
              @click="filtersAreOpen = !filtersAreOpen"
            >
              <i class="fal fa-times me-2"></i>{{ $store.state.i18n.close }}
            </button>
          </show-at>
        </div>
      </div>
    </div>
    <div ref="spacer"></div>

    <div class="tags-list mt-4">
      <TagBadge
        v-for="tag in $store.state.filterTags"
        :key="tag.type_name + '_' + tag.term_id"
        :tag="tag"
      />
    </div>
  </div>
</template>

<script>
import PosttypeFilter from "./parts/PosttypeFilter";
import CheckboxFilter from "./parts/CheckboxFilter";
import TagBadge from "./parts/TagBadge";
import gsap from "../../../node_modules/gsap/dist/gsap.js";
import { showAt, hideAt } from "vue-breakpoints";

export default {
  name: "Filters",
  components: {
    PosttypeFilter,
    CheckboxFilter,
    TagBadge,
    showAt,
    hideAt,
  },

  data() {
    return {
      filtersAreOpen: false,
      debounce: null,
    };
  },

  watch: {
    filtersAreOpen: function (val, oldVal) {
      let spacerHeight = 0;

      if (val) {
        spacerHeight = this.$refs.dropdown.offsetHeight;
      }

      gsap.to(this.$refs.spacer, {
        height: spacerHeight,
        duration: 0.25,
        onComplete: function () {
          window.dispatchEvent(new Event("resize"));
        },
      });
    },
  },

  methods: {
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.$store.commit("UPDATE_SEARCH", event.target.value);
        this.$store.dispatch("newRequest");
        window.dataLayer.push({
          event: "generic_event",
          event_category: "engagement",
          event_action: "section_search",
          event_label: event.target.value,
          event_name: "section_search",
        });
      }, 1000);
    },

    tagClick(tagName, tag) {
      if (!this.$store.state.tags.includes(tag)) {
        this.$store.commit("ADD_TAG", [tagName, tag]);
        this.$store.dispatch("newRequest");
      }
    },
  },
};
</script>
